<span>{{fact.Label}}:</span> {{fact.Detail}}